export const TAG = 'CashBalance';
export enum CASH_ACTION {
  WITHDRAWAL = 'WITHDRAWAL',
  DEPOSIT = 'DEPOSIT',
  TRANSFER = 'TRANSFER',
  FX_INSTRUCTIONS = 'FX_INSTRUCTIONS',
  NONE = 'NONE',
}
